import { render, staticRenderFns } from "./EntityInformation.vue?vue&type=template&id=01bb1351&scoped=true&"
import script from "./EntityInformation.vue?vue&type=script&lang=js&"
export * from "./EntityInformation.vue?vue&type=script&lang=js&"
import style0 from "./EntityInformation.vue?vue&type=style&index=0&id=01bb1351&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bb1351",
  null
  
)

export default component.exports